import { render, staticRenderFns } from "./NewsReadersVisorItem.vue?vue&type=template&id=19a67e59&scoped=true"
import script from "./NewsReadersVisorItem.vue?vue&type=script&lang=js"
export * from "./NewsReadersVisorItem.vue?vue&type=script&lang=js"
import style0 from "./NewsReadersVisorItem.vue?vue&type=style&index=0&id=19a67e59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a67e59",
  null
  
)

export default component.exports